import CashSvg from 'assets/icons/navigation/cash.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(CashSvg, { displayName: 'CashIcon' });
